import React from "react";
import { InfoPopup } from "../components/PopupTemplate";

/**
 * PopupRenderer
 *
 * Single entry point the rest of the app uses to show a backend-driven
 * popup. It looks at popupData.type and hands off to the matching
 * template. Unknown/unsupported types fail safely (render nothing)
 * instead of crashing the app.
 *
 * Usage:
 *   <PopupRenderer open={open} onClose={onClose} popupData={popupData} />
 *
 * popupData shape (from backend):
 *   {
 *     title: string,
 *     msg: string,      // Markdown
 *     type: string,     // "info" for now
 *     action: string,   // reserved for future action-capable types
 *   }
 */
const PopupRenderer = ({ open, onClose, popupData }) => {
    if (!popupData) return null;

    switch (popupData.type) {
        case "info":
        case "insight":
        case "action":
        case undefined:
            return (
                <InfoPopup
                    open={open}
                    onClose={onClose}
                    popupData={popupData}
                />
            );

        // Future types plug in here, e.g.:
        // case "action":
        //     return <ActionPopup open={open} onClose={onClose} popupData={popupData} />;
        // case "notification":
        //     return <NotificationPopupV2 open={open} onClose={onClose} popupData={popupData} />;

        default:
            // Unknown type — log for visibility, but never crash the app
            // over a popup. Silently render nothing.
            if (process.env.NODE_ENV !== "production") {
                // eslint-disable-next-line no-console
                console.warn(
                    `PopupRenderer: unsupported popup type "${popupData.type}"`,
                );
            }
            return null;
    }
};

export default PopupRenderer;
